export default "__VITE_ASSET__0df70c49__"